import React from 'react';
import SearchBar from './search-bar';
import SearchText from './search-text';
import SearchButton from './search-button';
import SearchDate from './search-date';

class SampleSearch extends React.Component {

    handleChange(data) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(data);
        }
    }

    render () {
        return (
            <div className={['component-sample-search', this.props.className].join(' ')}>
                <div className="desktop-search border-wrapper">
                    <SearchBar onSearch={this.props.onSearch} onChange={(e, data) => this.handleChange(data)} autoSearch={this.props.autoSearch} searchValues={this.props.searchValues}>
                        <SearchText defaultValue={this.props.searchParams.searchText} name="text" />
                        <SearchDate 
                            defaultValue={this.props.searchParams.dateFrom} 
                            placeholder="Min Date" 
                            name="dateMin" />
                        <SearchDate 
                            defaultValue={this.props.searchParams.dateTo} 
                            placeholder="Max Date" 
                            name="dateMax" />
                        <SearchButton className="primary" />
                    </SearchBar>
                </div>
                <div className="mobile-search">
                    <SearchBar onSearch={this.props.onSearch} onChange={(e, data) => this.props.handleChange(data)} autoSearch={this.props.autoSearch} searchValues={this.props.searchValues}>
                        <div className="mobile-search-text border-wrapper">
                            <SearchText defaultValue={this.props.searchParams.searchText} name="text" />
                            <SearchButton className="primary" />
                        </div>
                        <div className="mobile-search-options border-wrapper">
                            <SearchDate defaultValue={this.props.searchParams.dateFrom} placeholder="Min Date" name="dateMin" />
                            <SearchDate defaultValue={this.props.searchParams.dateTo} placeholder="Max Date" name="dateMax" />
                        </div>
                    </SearchBar>
                </div>
            </div>
        )
    }
}

export default SampleSearch;



// WEBPACK FOOTER //
// ./web-app/components/sample-search.jsx